module.exports = {
  title: "sewon.dev",
  description:
    "프로젝트를 만들고 운영하면서 배운 개발, 제품, 디버깅 기록을 남깁니다.",
  author: "givemethatsewon",
  siteUrl: "https://sewon.dev",
  links: {
    github: "https://github.com/givemethatsewon",
    linkedIn: "https://www.linkedin.com/in/givemethatsewon/",
    facebook: "",
    twitter: "",
    x: "",
    instagram: "https://www.instagram.com/attention.plz._/",
    medium: "",
    blogger: "",
    email: "mailto:nvpz1598@gmail.com",
    resume: "",
    link: "",
  },
  analytics: {
    googleMeasurementId: "G-88Q3Z12E5L",
  },
  useAbout: true,
  giscus: {
    enabled: false,
    repo: "",
    repoId: "",
    category: "",
    categoryId: "",
    mapping: "pathname",
    strict: "0",
    reactionsEnabled: "1",
    inputPosition: "bottom",
    lang: "ko",
  },
}
